import { render } from "./Form.vue?vue&type=template&id=288167a0&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=288167a0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-288167a0"

export default script